export const FETCH_AUCTION_STARTED = 'FETCH_AUCTION_STARTED';
export const FETCH_AUCTION_COMPLETED = 'FETCH_AUCTION_COMPLETED';
export const FETCH_AUCTION_ERROR = 'FETCH_AUCTION_ERROR';

export const FILTER_AUCTION_STARTED = 'FILTER_AUCTION_STARTED';
export const FILTER_AUCTION_COMPLETED = 'FILTER_AUCTION_COMPLETED';
export const FILTER_AUCTION_ERROR = 'FILTER_AUCTION_ERROR';

export const FETCH_COLLECTION_STARTED = 'FETCH_COLLECTION_STARTED';
export const FETCH_COLLECTION_COMPLETED = 'FETCH_COLLECTION_COMPLETED';
export const FETCH_COLLECTION_ERROR = 'FETCH_COLLECTION_ERROR';

export const FILTER_COLLECTION_STARTED = 'FILTER_COLLECTION_STARTED';
export const FILTER_COLLECTION_COMPLETED = 'FILTER_COLLECTION_COMPLETED';
export const FILTER_COLLECTION_ERROR = 'FILTER_COLLECTION_ERROR';

export const CLEAR_COLLECTIONS = 'CLEAR_COLLECTIONS';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/reportActionTypes.js